// Single source of truth for the backend API base URL.
//
// In dev: set REACT_APP_API_BASE in .env.development.local (e.g.
//   REACT_APP_API_BASE=http://localhost:8000/api
// ) so the local frontend talks to the local Docker backend.
//
// In prod builds: the env var is unset, so we fall back to the deployed
// backend at fly.dev. Vercel can override this via project env vars if
// needed (REACT_APP_* are baked in at build time).
export const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://wms-gourmitalia.fly.dev/api';
